;

module.exports = function(posA, posB) {
	return posB - posA;
};
